import React from "react";
import { config } from "../../data/config";

function Contact() {

    const {socialLinks} = config;

  return (
    <div>
      <section className="text-gray-700 body-font border-t border-gray-200">
        <div className="container px-5 py-24 mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden">
            <div
              className="mapouter"
              style={{
                position: "relative",
                textAlign: "right",
                height: "500px",
                width: "600px",
              }}
            >
              <div
                className="gmap_canvas"
                style={{
                  overflow: "hidden",
                  background: "none!important",
                  height: "500px",
                  width: "600px",
                }}
              >
                <iframe
                  width="600"
                  height="500"
                  id="gmap_canvas"
                  src="https://maps.google.com/maps?q=Casablanca&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
                <a href="https://123movies-to.org">123movies</a>
                <br />
                <a href="https://www.embedgooglemap.net">
                  adding a google map to a website
                </a>
              </div>
            </div>
          </div>
          <div className="flex flex-col flex-wrap -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
            <p className="font-bold text-black text-2xl text-center">
              <span
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #84fab0 0%, #6366f1 100%)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100% 0.2em",
                  backgroundPosition: "0 88%",
                  transition: "background-size 0.25s ease-in",
                }}
                className="dark:text-white"
              >
                Contact Details
              </span>
            </p>
            <p className="mt-6 text-xl font-semibold dark:text-slate-400">
              Hi 👋 How are you? <br />
              Thank you for visiting My Portfolio. If you have any inquiries or
              feedback, please don't hesitate to reach out. I am available at :
            </p>
            <p className="font-semibold mt-6 text-xl mb-3">
                <span className="border-b dark:text-white">SOCIAL MEDIA :</span>
              </p>
            <div className="flex w-full my-4 justify-center md:justify-start  md:w-auto">
              <a className="text-indigo-500" href={socialLinks.facebook}>
                <svg
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-8 h-8"
                  viewBox="0 0 24 24"
                >
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                </svg>
              </a>
              <a className="ml-3 text-indigo-500" href={socialLinks.twitter}>
                <svg
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-8 h-8"
                  viewBox="0 0 24 24"
                >
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
                </svg>
              </a>
              <a className="ml-3 text-indigo-500" href={socialLinks.instagram}>
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-8 h-8"
                  viewBox="0 0 24 24"
                >
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
                </svg>
              </a>
              <a className="ml-3 text-indigo-500" href={socialLinks.linkedin}>
                <svg
                  fill="currentColor"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="0"
                  className="w-8 h-8"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="none"
                    d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                  ></path>
                  <circle cx="4" cy="4" r="2" stroke="none"></circle>
                </svg>
              </a>
            </div>
            <div className="mt-6">
              <p className="font-semibold text-xl mb-3">
                <span className="border-b dark:text-white">ELECTRONIC MAIL :</span>
              </p>
              <a className="text-center dark:text-slate-400" href="mailto:abdelmaleke201@gmail.com">
                abdelmaleke201@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
